import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { AdsAndSmbsRecord } from "../../../redux/types/reportTypes";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const headers = [
  {
    label: "Cluster",
    key: "cluster",
  },
  {
    label: "Name",
    key: "name",
  },
  {
    label: "PUB ID",
    key: "publisher",
  },
  {
    label: "Origami",
    key: "origami",
  },
  {
    label: "SMBS",
    key: "smbs",
  },
  {
    label: "ADS",
    key: "ads",
  },
  {
    label: "ADS PER SMB",
    key: "adsPerSmb",
  },
];

type AdsAndSmbsCSVProps = {
  data: Array<AdsAndSmbsRecord>;
};

const AdsAndSmbsCSV = ({ data }: AdsAndSmbsCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default AdsAndSmbsCSV;
